export default __webpack_public_path__ + "static/media/unionb.453e9107.png";